// API configuration
export const API_URL = import.meta.env.VITE_API_URL || 'https://hike-rank-backend.onrender.com/api'